import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f8810d8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"white-space":"pre-wrap"} }
const _hoisted_2 = { class: "wrapper valign" }
const _hoisted_3 = { class: "swiper-zoom-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_slide = _resolveComponent("ion-slide")!
  const _component_ion_slides = _resolveComponent("ion-slides")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_ion_header, null, {
      default: _withCtx(() => [
        _createVNode(_component_ion_toolbar, null, {
          default: _withCtx(() => [
            (_ctx.caption)
              ? (_openBlock(), _createBlock(_component_ion_title, {
                  key: 0,
                  size: "small"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.caption), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_buttons, { slot: "end" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_button, {
                  slot: "icon-only",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_ion_icon, { icon: _ctx.close }, null, 8, ["icon"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_component_ion_slides, {
            pager: "false",
            options: _ctx.slideOpts
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_slide, null, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_3, [
                    (_ctx.isPetCardImg)
                      ? (_openBlock(), _createElementBlock("img", {
                          key: 0,
                          style: {"border-radius":"40px"},
                          class: "main-img",
                          src: _ctx.imageLink
                        }, null, 8, _hoisted_4))
                      : (_openBlock(), _createElementBlock("img", {
                          key: 1,
                          class: "main-img",
                          src: _ctx.imageLink
                        }, null, 8, _hoisted_5))
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["options"])
        ])
      ]),
      _: 1
    })
  ], 64))
}